import { map,wrap } from '@codeArt/utils/promise';
import { type } from '../utils/common';

const _ = require("lodash");
function Contribution(){

    const items = [];

    this.items = ()=> items;

    const handlers = {};

    this.register = (contributes)=>{   //注册贡献点的处理程序
        return wrap((resolve, reject) => {
            if(!contributes || contributes.length===0) return resolve();
            Promise.all(contributes.map((c)=> addHandler(c))).then(resolve).catch(reject);
        });
    }

    const addHandler = ({id,title,description,handler})=>{
        return wrap((resolve, reject) => {
            handler().then((h)=>{
                handlers[id]=h.process || h.default;
                items.push({id,title,description});
            }).catch(reject);
        });
    }

    this.dispatch = (plugin)=>{    //分发贡献点
        const {contributes} = plugin;
        return wrap((resolve, reject) => {
           let promises = [];
            for(let id in contributes){
                let contribute = contributes[id];
                let handler = handlers[id];
                if(handler) {
                    let p = map(handler,contribute,plugin);  //注意，到这一步其实已经开始执行了
                    promises.push(p);
                }
           }
           Promise.all(promises).then((exacts)=>{
            exacts = _.filter(exacts,(e)=> Boolean(e));
            resolve(exacts);
           }).catch(reject); //在这一步，统一返回结果
        });
    }
    
}

export {Contribution};